(function ($) {
    "use strict";

    class PostGridAPI {
        static instance = null;
        defaultArgs = {
            action: "syn_load_more_posts",
            nonce: synPostGrid.nonce,
            post_type: "",
            posts_per_page: 12,
            orderby: "",
            order: "",
            page: 1,
            category: "",
            tag: "",
            search: "",
            pre_filtered: false,
        };

        constructor() {
            if (PostGridAPI.instance) {
                return PostGridAPI.instance;
            }

            PostGridAPI.instance = this;
        }

        get(args = {}) {
            const mergedArgs = { ...this.defaultArgs, ...args };

            return $.ajax({
                url: synPostGrid.ajax_url,
                type: "POST",
                data: mergedArgs,
            });
        }
    }

    class PostGridURL {
        static instance = null;

        constructor() {
            if (PostGridURL.instance) {
                return PostGridURL.instance;
            }

            PostGridURL.instance = this;
        }

        get() {
            let url = window.location.href;

            return url;
        }

        paginate(page) {
            const urlObj = new URL(this.get());
            // Remove any existing /page/{number} from the pathname
            urlObj.pathname = urlObj.pathname.replace(/\/page\/\d+\/?$/, "");
            // Append /page/{page} to the pathname (unless page is 1)
            if (page > 1) {
                // Ensure the pathname does not end with a slash before appending
                urlObj.pathname = urlObj.pathname.replace(/\/$/, "") + `/page/${page}/`;
            }
            // @TODO change to use popstate instead of pushState
            window.history.replaceState({}, "", urlObj.toString());
            return urlObj.toString();
        }
    }

    class PostGridFilter {
        constructor(element) {
            this.element = element;
            this.$el = jQuery(element);
            this.id = this.$el.attr("id") || "post-grid-filter-" + Date.now();
        }

        init() {
            // Initialization code here
        }

        listen() {
            // Event listeners here
        }
    }

    class PostGridFilterCollection {
        filters = [];

        constructor() {
            this.filters = [];
        }

        add(filter) {
            this.filters.push(filter);
        }

        remove(filter) {
            this.filters = this.filters.filter((f) => f !== filter);
        }

        getAll() {
            return this.filters;
        }
    }

    /**
     * PostGrid Class
     *
     * This class manages the post grid functionality, including loading posts,
     * handling filters, and managing the grid state.
     *
     * @class PostGrid
     * @property {string} eventPrefix - Prefix for custom events.
     * @property {HTMLElement} element - The DOM element for the post grid.
     * @property {jQuery} $el - jQuery object for the post grid element.
     * @property {jQuery} $gridItems - jQuery object for the grid items container.
     * @property {string} id - Unique identifier for the post grid instance.
     * @property {PostGridAPI} api - Instance of PostGridAPI for AJAX requests.
     * @property {PostGridURL} url - Instance of PostGridURL for URL management.
     * @property {PostGridFilterCollection} filters - Collection of filters applied to the post grid.
     *
     * @event PostGrid:created - Triggered when a new PostGrid instance is created.
     * @event PostGrid:dataChanged - Triggered when the data attributes of the post grid changes.
     * @event PostGrid:loadMore - Triggered when the "Load More" button is clicked before loading more posts.
     */
    class PostGrid {
        eventPrefix = "PostGrid:";

        constructor(element) {
            this.element = element;
            this.$el = jQuery(element);
            this.id = this.$el.attr("id") || "post-grid-" + Date.now();
            this.$gridItems = this.$el.find(".syn-post-grid-items");
            this.api = new PostGridAPI();
            this.url = new PostGridURL();
            this.filters = new PostGridFilterCollection();

            this.init();
            this.listen();
        }

        get data() {
            return {
                id: this.id,
                baseUrl: this.$el.data("base-url") || "",
                postType: this.$el.data("post-type"),
                postsPerPage: this.$el.data("posts-per-page"),
                orderby: this.$el.data("orderby"),
                order: this.$el.data("order"),
                page: this.$el.data("page"),
                maxPages: this.$el.data("max-pages"),
                preFiltered: this.$el.data("pre-filtered") || false,
                queriedObjectTaxonomy: this.$el.data("queried-object-taxonomy") || "",
                queriedObjectTerm: this.$el.data("queried-object-term") || "",
                cardSize: this.$el.data("card-size") || "default",
                categoryFilter: this.$el.data("category-filter") || "",
            };
        }

        set data(newData) {
            if (typeof newData === "object") {
                for (const key in newData) {
                    let hyphenCaseKey = this.toHyphenCase(key);

                    if (this.$el.data(hyphenCaseKey) !== undefined) {
                        this.$el.data(hyphenCaseKey, newData[key]);
                        this.$el.attr(`data-${hyphenCaseKey}`, newData[key]);

                        this.emit("dataChanged", {
                            key: key,
                            value: newData[key],
                        });
                    }
                }
            } else {
                console.error("Data must be an object { key: value }");
            }
        }

        normalizeDataForAPI() {
            return {
                post_type: this.data.postType,
                posts_per_page: this.data.postsPerPage,
                orderby: this.data.orderby,
                order: this.data.order,
                page: this.data.page,
                pre_filtered: this.data.preFiltered,
                queried_object_taxonomy: this.data.queriedObjectTaxonomy,
                queried_object_term: this.data.queriedObjectTerm,
                card_size: this.data.cardSize,
                category_filter: this.data.categoryFilter,
            };
        }

        init() {
            this.emit("created", this);
            
            // Check if there's a category parameter in the URL and apply it
            this.checkURLForCategory();
        }

        emit(eventName, data) {
            this.$el.trigger(`${this.eventPrefix}${eventName}`, [data]);
        }

        listen() {
            // Event listeners here
            this.$el.on("click", ".syn-post-grid-load-more", (event) => {
                event.preventDefault();

                this.emit("loadMore", this);
                this.handleClickLoadMore(event);
            });
            
            // Category filter change event
            this.$el.on("change", ".category-filter-dropdown", (event) => {
                //console.log('Category filter change event triggered');
                event.preventDefault();
                this.handleCategoryFilterChange(event);
            });
            
            // Debug: Check if dropdown exists
            const dropdown = this.$el.find('.category-filter-dropdown');
            //console.log('Category dropdown found:', dropdown.length > 0);
            if (dropdown.length > 0) {
                //console.log('Dropdown options:', dropdown.find('option').length);
            }
        }

        handleClickLoadMore() {
            const nextPage = parseInt(this.$el.data("page"), 10) + 1;
            const maxPages = parseInt(this.$el.data("max-pages"), 10);

            if (nextPage <= maxPages) {
                this.data = { 'page': nextPage };

                this.loadMorePosts(nextPage);
            }
        }
        
        handleCategoryFilterChange(event) {
            const selectedCategory = $(event.target).val();
            
            //console.log('Category filter changed to:', selectedCategory);
            
            // Update the category filter data
            this.data = { 'categoryFilter': selectedCategory };
            
            // Reset to page 1 when filtering
            this.data = { 'page': 1 };
            
            // Update URL with category parameter and reset pagination
            this.updateURLWithCategory(selectedCategory);
            
            // Load filtered posts (pass empty string for "All" category)
            this.loadFilteredPosts(selectedCategory || '');
        }

        async loadMorePosts(page) {
            try {
                this.$el.trigger('loader:show');

                let payload = this.normalizeDataForAPI();
                payload.page = page;

                const response = await this.api.get(payload);
                
                // Handle successful response
                if (response.success && response.data.html) {
                    // Append new posts
                    this.$gridItems.append(response.data.html);
                    // Update the url
                    this.url.paginate(page);
                    // Update the page data attribute
                    let url = this.url.get();
                    var next_page = page + 1;
                    if (next_page > this.data.maxPages){
                        this.$el.find(".syn-post-grid-load-more").hide();
                    }else{
                        this.$el.find(".syn-post-grid-load-more").show();
                    }
                    url = url.replace(/\/page\/\d+\/?$/, `/page/${page+1}/`);
                    this.$el.find(".syn-post-grid-load-more").attr("href", url);
                } else {
                    console.error("Error in load more response:", response);
                }

                this.$el.trigger('loader:hide');
            } catch (error) {
                // Handle error
                console.error(error);
            }
        }
        
        async loadFilteredPosts(category) {
            try {
                this.$el.trigger('loader:show');

                let payload = this.normalizeDataForAPI();
                payload.page = 1; // Always start from page 1 when filtering
                payload.category_filter = category;
                payload.nonce = synPostGrid.nonce; // Ensure nonce is included
                payload.action = 'syn_load_more_posts'; // Ensure action is included

                //console.log('Sending filter payload:', payload);

                const response = await this.api.get(payload);
                
                // Handle successful response
                if (response.success && response.data.html) {
                    // Replace all posts with filtered results
                    this.$gridItems.html(response.data.html);
                    
                    // Update max pages for the filtered results
                    this.data = { 'maxPages': response.data.max_pages };
                    
                    // Update load more button visibility and reset pagination
                    this.updateLoadMoreButton(response.data.max_pages);
                    this.resetPagination();
                    
                    // Reset page to 1
                    this.data = { 'page': 1 };
                } else {
                    console.error("Error in filter response:", response);
                }

                this.$el.trigger('loader:hide');
            } catch (error) {
                // Handle error
                console.error(error);
            }
        }
        
        updateLoadMoreButton(maxPages) {
            const loadMoreWrapper = this.$el.find('.syn-post-grid-load-more-wrapper');
            if (maxPages > 1) {
                loadMoreWrapper.show();
            } else {
                loadMoreWrapper.hide();
            }
        }
        
        updateURLWithCategory(category) {
            const currentUrl = new URL(window.location.href);
            
            // Remove any existing page parameter
            currentUrl.searchParams.delete('page');
            
            // Remove any existing category parameter
            currentUrl.searchParams.delete('category');
            
            // Add the new category parameter if one is selected
            if (category && category !== '') {
                currentUrl.searchParams.set('category', category);
            }
            
            // Remove /page/X/ from the pathname
            currentUrl.pathname = currentUrl.pathname.replace(/\/page\/\d+\/?$/, '');
            
            // Update the URL without reloading the page
            window.history.pushState({}, '', currentUrl.toString());
            
            //console.log('URL updated to:', currentUrl.toString());
        }
        
        resetPagination() {
            // Reset the page data attribute
            this.$el.attr('data-page', '1');
            
            // Update the load more button href to remove page parameter and pathname pagination
            const loadMoreButton = this.$el.find('.syn-post-grid-load-more');
            if (loadMoreButton.length > 0) {
                const currentUrl = new URL(loadMoreButton.attr('href') || window.location.href);
                currentUrl.searchParams.delete('page');
                // Remove /page/X/ from the pathname
                currentUrl.pathname = currentUrl.pathname.replace(/\/page\/\d+\/?$/, '');
                loadMoreButton.attr('href', currentUrl.toString());
            }
            
            //console.log('Pagination reset to page 1');
        }
        
        checkURLForCategory() {
            const urlParams = new URLSearchParams(window.location.search);
            const categoryParam = urlParams.get('category');
            
            if (categoryParam && this.$el.find('.category-filter-dropdown').length > 0) {
                // Set the dropdown to the category from URL
                this.$el.find('.category-filter-dropdown').val(categoryParam);
                
                // Update the data attribute
                this.data = { 'categoryFilter': categoryParam };
                
                //console.log('Category from URL applied:', categoryParam);
                
                // Load the filtered posts for this category
                this.loadFilteredPosts(categoryParam);
            }
        }

        toSnakeCase(str) {
            return str
                .replace(/([a-z])([A-Z])/g, "$1_$2")
                .replace(/[\s-]+/g, "-")
                .toLowerCase();
        }

        toHyphenCase(str) {
            return str
                .replace(/([a-z])([A-Z])/g, "$1-$2")
                .replace(/[\s_]+/g, "-")
                .toLowerCase();
        }
    }

    class PostGridFactory {
        static collection = [];

        static create(element) {
            const instance = new PostGrid(element);
            this.collection.push(instance);
            return instance;
        }

        static getAll() {
            return this.collection;
        }

        static getById(id) {
            return this.collection.find((instance) => instance.id === id);
        }

        static getByIndex(index) {
            return this.collection[index] || null;
        }
    }

    $(document).ready(function () {
        // Initialize PostGrid instances
        $(".syn-post-grid").each(function () {
            PostGridFactory.create(this);
        });
    });
})(jQuery);